var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#A88E86",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M9.167 15a5.833 5.833 0 1 0 0-11.667 5.833 5.833 0 0 0 0 11.667Z"
  }), /*#__PURE__*/React.createElement(Path, {
    strokeLinecap: "round",
    d: "M16.667 16.667 13.5 13.5"
  }))));
};
export default SvgIconSearch;